module.exports = __webpack_public_path__ + "img/AP_ico_alert.6e39539f.svg";